module.exports = __webpack_public_path__ + "static/images/settings-sliders.b25b414b5960aac80b6907c7b6eac90d.svg";